This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div class="basicBlock classroomBlock">
    <p class="header upper">
      {{ $t("classroomPackages.myClasses") }}
    </p>
    <div>
      <div
        class="blockEntry grid-cols-5 selectable buttonsRight leftRight"
        v-for="c in this.classrooms"
        :class="[
          c?.classroomId === selected?.classroomId ? 'selected' : 'selectable',
        ]"
        :key="c.classroomId"
        @click="changeSelectedClassroom(c)"
      >
        <p>{{ c.name }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { classroom } from "@/utils/Types";
import { Vue, Options } from "vue-class-component";
import { classAPI } from "@/utils/apiCalls";

@Options({
  data() {
    return {
      selected: null,
      classrooms: [],
      overlay: false,
    };
  },
  methods: {
    //Update classrooms on change
    async updateMyClassrooms() {
      await classAPI.getAllClassroomsOfSchool().then((value) => {
        this.classrooms = value;
      });
    },
    /**
     * Change selected classroom
     * @param c Classroom
     */
    changeSelectedClassroom(c: classroom) {
      this.selected = c;
      this.$emit("updateClassroom", c);
    },
  },
  mounted() {
    this.updateMyClassrooms();
  },
})
export default class MyClassroomsBlock extends Vue {}
</script>
